import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MutationButton from './MutationButton';
import { extendedMutationType } from '../../types';

SaveButton.propTypes = {
    extendedMutation: extendedMutationType.isRequired,
    confirmationMessage: PropTypes.string.isRequired,
    extraConfirmationMessage: PropTypes.string,
    showConfirmationDialog: PropTypes.bool,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    icon: PropTypes.string,
};

function SaveButton(props) {
    const {
        extendedMutation,
        confirmationMessage,
        extraConfirmationMessage = null,
        showConfirmationDialog = false,
        disabled = false,
        label = null,
        icon = null,
    } = props;
    const { t } = useTranslation();
    return (
        <MutationButton
            className="save-button button-bordered button"
            confirmationMessage={confirmationMessage}
            extraConfirmationMessage={extraConfirmationMessage}
            showConfirmationDialog={showConfirmationDialog}
            disabled={disabled}
            extendedMutation={extendedMutation}
        >
            <FontAwesomeIcon icon={icon || 'check'} />&nbsp;{label || t('button.save')}
        </MutationButton>
    );
}

export default SaveButton;
